import { render, staticRenderFns } from "./SetPallet.vue?vue&type=template&id=b1fbefe6"
import script from "./SetPallet.vue?vue&type=script&lang=js"
export * from "./SetPallet.vue?vue&type=script&lang=js"
import style0 from "./SetPallet.vue?vue&type=style&index=0&id=b1fbefe6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports